import React from 'react';
import PropTypes from 'prop-types';

import Flyout from './Flyout/FlyoutController';
import NavLink from './NavLink/NavLink';
import SearchForm from './SearchForm/SearchForm';
import SocialMediaDropDown from './SocialMediaDropDown/SocialMediaDropDown';

// import assets
import Logo from '../../../../assets/images/ZEISS_Brand_CMYK.svg';
import '../../../../assets/icons/Logo_Lenspire_Photo.svg';
import '../../../../assets/icons/Lenspire_Icon_Search.svg';
import '../../../../assets/icons/Lenspire_Icon_CloseGlobal.svg';
import './headerDesktop.scss';

const HeaderDesktopView = props => (
  <header className={props.flyoutVisible ? 'm-header--desktop m-header--fixed' : 'm-header--desktop'}>
    <div className={'m-header__upper'}>
      <div className={'m-header__logo'} onClick={props.goHome} role={'link'} tabIndex={-1}>
        <img src={Logo} alt="Zeiss Logo" />
      </div>
      <div className={'m-header__title'} onClick={props.goHome} role={'link'} tabIndex={-1}>
        <svg>
          <use xlinkHref="#Logo_Lenspire_Photo" />
        </svg>
      </div>
      <div className={'m-header__links'}>
        <ul className="m-header__link-list">
          {
            Object.keys(props.links.statics).map(link => (
              <li className="m-header__link-list-item" key={link}><a
                className="m-header__link"
                href={props.links.statics[link].url}
                target={props.links.statics[link].blank ? '_blank' : '_self'}
                rel="noopener"
              >{props.links.statics[link].label}</a></li>
            ))
          }
          <li><SocialMediaDropDown text={props.links['some-label']} channels={props.some} /></li>
        </ul>
      </div>
    </div>
    <div className={'m-header__lower'}>
      <div className={'m-header__spacer'} />
      <div className={'m-header__nav'}>
        <ul>
          {
            Object.keys(props.categories).map(category => (
              <NavLink
                key={category}
                category={props.categories[category]}
                openFlyout={props.openFlyout}
                toggleFlyout={props.toggleFlyout}
                flyoutVisible={props.flyoutVisible}
                setHashByActiveSubCategories={props.setHashByActiveSubCategories}
              />
            ))
          }
        </ul>
      </div>
      <div className={'m-header__search'} onClick={props.flyoutVisible ? props.toggleFlyout : props.toggleSearch} role="button" tabIndex={-1}>
        <svg>
          <use xlinkHref={props.searchVisible || props.flyoutVisible ? '#Lenspire_Icon_CloseGlobal' : '#Lenspire_Icon_Search'} />
        </svg>
      </div>
    </div>
    <SearchForm visible={props.searchVisible} />
    <Flyout
      visible={props.flyoutVisible}
      toggleFlyout={props.toggleFlyout}
      closeFlyout={props.closeFlyout}
      mobile={false}
      setHashByActiveSubCategories={props.setHashByActiveSubCategories}
    />
  </header>
);

HeaderDesktopView.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        image: PropTypes.shape,
        title: PropTypes.string,
      })),
    }),
  ),
  links: PropTypes.shape({
    'some-label': PropTypes.string,
    statics: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      blank: PropTypes.bool,
      url: PropTypes.string,
    })),
  }),
  some: PropTypes.shape({
    yt: PropTypes.string,
    vimeo: PropTypes.string,
    fb: PropTypes.string,
    twitter: PropTypes.string,
    instagram: PropTypes.string,
    google: PropTypes.string,
  }),
  flyoutVisible: PropTypes.bool,
  searchVisible: PropTypes.bool,
  toggleFlyout: PropTypes.func,
  toggleSearch: PropTypes.func,
  openFlyout: PropTypes.func,
  closeFlyout: PropTypes.func,
  setHashByActiveSubCategories: PropTypes.func.isRequired,
  goHome: PropTypes.func.isRequired,
};

HeaderDesktopView.defaultProps = {
  categories: [],
  links: {
    'some-label': '',
    statics: [],
  },
  some: {
    yt: '',
    vimeo: '',
    fb: '',
    twitter: '',
    instagram: '',
    google: '',
  },
  flyoutVisible: false,
  searchVisible: false,
  toggleSearch: () => {
  },
  toggleFlyout: () => {
  },
  openFlyout: () => {
  },
  closeFlyout: () => {
  },
  lang: 'en',
};

export default (HeaderDesktopView);



// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Header/HeaderDesktopView.jsx